module.exports = __webpack_public_path__ + "img/fc3d.8fb649c2.jpg";